import {Component, Input, OnInit} from '@angular/core';
import {StudentRequestComponent} from "../modals/student-request/student-request.component";
import {ModalController} from "@ionic/angular";
import {EnglishLevelApiResponse} from "../../../types/apiResponse.interface";
import {PreloaderService} from "../../../services/preloader/preloader.service";
import {StudentService} from "../../../services/mygreencountry/student.service";
import {MyGreenCountry} from "../../../services/mygreencountry/my-greencountry";

@Component({
    selector: 'app-old-student-info',
    templateUrl: './old-student-info.component.html',
    styleUrls: ['./old-student-info.component.scss'],
})
export class OldStudentInfoComponent implements OnInit {

    @Input() doTest: boolean | undefined = undefined;
    // @Input() withoutCertificates: boolean = true;
    @Input() doRegister: boolean = true;

    withoutCertificates: boolean = true;

    constructor(private modalCtrl: ModalController,
                private preloaderService: PreloaderService,
                private studentService: StudentService,
                private GCService: MyGreenCountry,) {
    }

    ngOnInit() {
    }

    async openRequestModal(type: string) {

        const modal = await this.modalCtrl.create({
            component: StudentRequestComponent,
            cssClass: 'chose-modal auto-height',
            componentProps: {
                type: type,
            }
        });

        await modal.present();
    }


    getEnglishLevelExamUrl() {
        this.preloaderService.showLoading('Зачекайте, будь ласка');

        this.studentService.getEnglishLevelTestUrl()

            .subscribe({

                next: (response: EnglishLevelApiResponse) => {

                    if (response.url) {
                        this.GCService.openUrl(response.url, '_self')
                    }

                },

                error: (error) => {

                    //@TODO: show error message
                    console.log('error', error)

                },

                complete: () => {
                    this.preloaderService.hideLoading();
                }
            })


    }

}
